import { CountryConfigNames } from '../../country-config-enums';
import { CountryUIFeature } from '../country-ui-feature';

export const DECountryUIConfig = [
  new CountryUIFeature(CountryConfigNames.InsuranceRecommendedBadgeHidden),
  new CountryUIFeature(CountryConfigNames.InsurancePromoBannerComplianceCopy),
  new CountryUIFeature(CountryConfigNames.InsuranceCoverageDetailsPopover, { disclaimerVariant: 'de' }),
  new CountryUIFeature(CountryConfigNames.InsuranceTermsAcknowledgement, { variant: 'de' }),
];
